import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { isOnlineActivity, PostItem } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { Checker, notNull, safeDate } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { Store } from '@ngrx/store';
import { isPast } from 'date-fns';
import { map, Observable } from 'rxjs';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './subtitle-activity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubtitleActivityComponent {
  protected readonly isEmployee: Signal<boolean>;
  protected readonly item = input<PostItem>();
  protected readonly data: Signal<PostItem[]>;
  private readonly _store = inject(Store);

  constructor() {
    this.isEmployee = toSignal(this.selectEmployee(), { initialValue: false });
    this.data = computed(() => {
      const item = this.item();
      if (this.isEmployee()) {
        const metadata = [item.metadata.group, item.metadata.subject, item.metadata.author];
        return metadata.filter((data) => !!data);
      }
      return [item.metadata.subject, item.metadata.author].filter((data) => !!data);
    });
  }

  protected canSubmit(item: PostItem): boolean {
    return isOnlineActivity(item.metadata.type);
  }

  protected isWarning(item: PostItem): string {
    const limit = safeDate(item.metadata.date_end);
    if (!this.isEmployee() && this.canSubmit(item) && !item.user_concludeds_count && isPast(limit)) {
      return 'text-red-500 font-semibold';
    }
    return 'text-title';
  }

  private selectEmployee(): Observable<boolean> {
    return this._store.select(AppSelectors.DefaultFunction).pipe(
      notNull(),
      map((functionId) => Checker.isEmployee(functionId)),
    );
  }
}
